/**
 * @description 系统全局配置
 */
export default {

  /**
   * @description token key
   */
  TokenKey: 'JR-SHOP-TOEKN',
    /**
   * @description token key
   */
  UserKey: 'JR-SHOP-USER',

  /**
   * @description 请求超时时间，毫秒（默认3分钟）
   */
  timeout: 180000,

  /**
   * @description 软件版本
   */
  edition: 'JRSHOP-CLIENT-0000000000'
}



// WEBPACK FOOTER //
// ./src/config/index.js